import React, { MouseEvent, PropsWithChildren, useState } from "react";
import { BaseCard, CardProps } from "../../../../../BaseCard";
import { CtaButton } from "../../../../../../components/CtaButton";
import { AlignedContent } from "../../../../../../styles";
import { Title } from "../../../../../../components/Title";
import { Wrapper } from "../../../../../CompletionCard/styles";

type Props = CardProps & {
  title: string;
  ctaText: string;
  showCtaButton: boolean;
  isLoading?: boolean;
  onClick: (event: MouseEvent<HTMLButtonElement>) => void;
};

export function BaseCompletionCard({
  isActive,
  children,
  title,
  ctaText,
  showCtaButton,
  isLoading,
  onClick,
  onCardActive,
}: PropsWithChildren<Props>) {
  // localstates needed because this button needs to be disabled
  // twice in it's lifetime. once when it's clicked and mutation is completed
  // and once when the two additional queries are called on onComplete hook of the mutation.
  const [_isLoading, _setIsLoading] = useState(false);

  const handleClick = async (e: MouseEvent<HTMLButtonElement>) => {
    _setIsLoading(true);
    await onClick(e);
    _setIsLoading(false);
  };

  return (
    <Wrapper>
      <BaseCard isActive={isActive} onCardActive={onCardActive}>
        <AlignedContent $align="center">
          <Title text={title} />
          {children}
          {showCtaButton && (
            <CtaButton
              text={ctaText}
              onClick={handleClick}
              loading={_isLoading || isLoading}
              disabled={_isLoading || isLoading}
            />
          )}
        </AlignedContent>
      </BaseCard>
    </Wrapper>
  );
}
